import { useGetMyProfile } from '@/api/gen/quiz-user/quiz-user.gen';
import { useUser } from '@/lib/auth';
import { PlanBadge } from '@/shared/components/Badge/PlanBadge';
import { UserAvatar } from '@/shared/features/user-avatar';
interface Props {
  /** Outer square size in pixels. Default 40. */
  size?: number;
  /** Hide the plan badge overlay (for contexts that show plan elsewhere). */
  hideBadge?: boolean;
}
export const ProfileIconButton = ({
  size = 40,
  hideBadge = false
}: Props) => {
  const {
    user
  } = useUser();
  const {
    data: myProfile
  } = useGetMyProfile({
    query: {
      enabled: !!user
    }
  });
  if (!user?.planType) return null;
  return <div className="relative" style={{
    width: `${size}px`,
    height: `${size}px`
  }} data-sentry-component="ProfileIconButton" data-sentry-source-file="ProfileIconButton.tsx">
      <UserAvatar avatarData={myProfile?.data.avatarData} size="md" className="size-full" planType={user.planType} data-sentry-element="UserAvatar" data-sentry-source-file="ProfileIconButton.tsx" />
      {!hideBadge && user.planType !== 'FREE' && <PlanBadge className="absolute -bottom-[4px] -right-[4px] scale-[0.82]" planType={user.planType} tooltip={false} />}
    </div>;
};